import memoizeOne from 'react-utils/memoizeOne';
import styled from 'styled-components';
import { viewportSizes } from '../utils/mediaQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultProps = {
  columns: {
    base: 12
  }
};
const createMediaQueries = memoizeOne((width, numColumns) => {
  if (!numColumns || !width) {
    return null;
  }
  return `
  @media screen and (min-width: ${width}px) {
    flex: ${`0 0 ${100 * (numColumns / 12)}%`}
  }`;
});
const StyledGridItem = styled.div.withConfig({
  displayName: "GridItem__StyledGridItem",
  componentId: "sc-13g00j7-0"
})(["flex:", ";", ";"], ({
  columns: {
    base
  }
}) => `0 0 ${100 * (base / 12)}%`, ({
  columns
}) => Object.entries(viewportSizes).map(([viewportSizeName, viewportWidth]) => createMediaQueries(viewportWidth, columns[viewportSizeName])));

/**
 * When used within a `Grid`, `GridItem` will fluidly resize on a 12-column
 * grid.
 */
const GridItem = (props = defaultProps) => /*#__PURE__*/_jsx(StyledGridItem, Object.assign({}, props));
GridItem.defaultProps = defaultProps;
export default GridItem;